export const API_CONFIG = {
  BASE_URL: "https://5d9wvre5lg.execute-api.us-east-1.amazonaws.com/dev",
  TIMEOUT: 30000, // 30 seconds
  ENDPOINTS: {
    SEARCH_HEADERS: "/amzl/v1/search-results",
    GET_LINES: "/amzl/v1/get-line-details",
    GET_SUBINVENTORY_LOV: "/amzl/v1/get-subinventory-lov",
    GET_LOCATOR_LOV: "/amzl/v1/get-locator-lov",
    GET_VALIDATED_SN_ITEM: "/amzl/v1/get-validated-sn-item",
    GET_SESSION_DTLS: "/amzl/v1/get-session-dtls",
  },
};
